<template>
  <ul>
    <li
      v-for="(header, i) in headers"
      :key="header"
      :class="{
        active: i + 1 === currentStep,
        finished: i + 1 < currentStep,
        hidden: canGoStepBackMobile(i + 1),
      }"
    >
      <div
        @click="goToStep(currentStep - 1)"
        class="number"
        v-if="currentStep > i + 1 && isMobileDevice"
      >
        <img :src="getIcon('triangle.svg')" />
      </div>
      <div @click="goToStep(i + 1)" class="number" v-else>
        <span>
          {{ i + 1 }}
        </span>
      </div>
      <div class="header-text" @click="goToStep(i + 1)">
        <div>{{ header }}</div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'HeaderSteps',

  props: {
    screenWidth: {
      type: Number,
      default: innerWidth,
    },
  },

  computed: {
    ...mapState('step', ['currentStep']),
    headers() {
      return [
        'Onderdelen selecteren',
        'Merk/kleur kiezen',
        'Bestellen/afronden',
      ];
    },
    isMobileDevice() {
      return this.screenWidth < 576;
    },
  },

  methods: {
    ...mapMutations('step', ['setStep']),
    ...mapActions('brand-color-selection', ['getBrandColorTypes']),
    goToStep(step) {
      if (step >= this.currentStep) {
        return;
      }

      if (step === 2) {
        this.getBrandColorTypes();
      } else if (step === 1) {
        this.$store.commit('brand-color-selection/setAllRoomsSelected', false);
      }

      this.setStep(step);
    },
    canGoStepBackMobile(step) {
      if (!this.isMobileDevice) return;

      return (
        this.currentStep > step + this.currentStep ||
        this.currentStep === step + 2
      );
    },
  },
};
</script>
